<script>
    // started from https://github.com/rsdavis/svelte-drawer
    import { onMount } from 'svelte'
    import { createEventDispatcher } from 'svelte'
    export let open = false
    export let duration = 0.2
    export let placement = 'left'
    export let size = null
    export let bgColor
    export let fontColor
    export let scrim = true
    let mounted = false
    const dispatch = createEventDispatcher()
    $: style = `--duration: ${duration}s; --size: ${size}; --bgcolor: ${bgColor}; --fontcolor: ${fontColor}`
    function scrollLock(open) {
        if (mounted) {
            const body = document.querySelector('body')
            body.style.overflow = open && scrim ? 'hidden' : 'auto'
        }
    }
    $: scrollLock(open)
    function handleClickAway() {
        dispatch('clickAway')
    }
    onMount(() => {
        mounted = true
        scrollLock(open)
    })
</script>

<style>
    .drawer {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: var(--size);
        z-index: -1;
        transition: z-index var(--duration) step-end;
    }
    .drawer.open {
        z-index: 99;
        transition: z-index var(--duration) step-start;
    }
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(100, 100, 100, 0.5);
        opacity: 0;
        z-index: 2;
        transition: opacity var(--duration) ease;
    }
    .drawer.open .overlay {
        opacity: 1;
    }
    .panel {
        position: fixed;
        width: 100%;
        height: 100%;
        background: white;
        z-index: 3;
        transition: transform var(--duration) ease;
        overflow: auto;
    }
    .panel.fno-side-menu {
        background-color: var(--bgcolor);
    }
    .panel.fno-side-menu :global(main, li.nav-item a) {
        color: var(--fontcolor);
        font-weight: bolder;
    }
    .panel.fno-side-menu :global(.fno-menu-hr) {
        margin-top: 0;
        background-color: #fff;
    }
    .panel.left {
        left: 0;
        transform: translate(-100%, 0);
    }
    .panel.right {
        right: 0;
        transform: translate(100%, 0);
    }
    .panel.top {
        top: 0;
        transform: translate(0, -100%);
    }
    .panel.bottom {
        bottom: 0;
        transform: translate(0, 100%);
    }
    .panel.left.size,
    .panel.right.size {
        max-width: var(--size);
    }
    .panel.top.size,
    .panel.bottom.size {
        max-height: var(--size);
    }
    .drawer.open .panel {
        transform: translate(0, 0);
    }
</style>

<aside class="drawer" class:open {style}>
    {#if scrim}
        <div class="overlay" on:click={handleClickAway} />
    {/if}

    <div class="panel fno-side-menu {placement}" class:size>
        <slot />
    </div>
</aside>
